export const StarBolderOutline = () => (
  <svg width="41" height="38" viewBox="0 0 41 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M38.4912 12.5655L27.5693 11.028L22.632 1.29054C21.8091 -0.39338 19.2657 -0.466594 18.368 1.29054L13.5055 11.028L2.50877 12.5655C0.563774 12.8584 -0.184302 15.2012 1.23704 16.5923L9.09184 24.1333L7.22165 34.7494C6.92242 36.6529 9.01703 38.1172 10.7376 37.2387L20.5374 32.1869L30.2624 37.2387C31.983 38.1172 34.0776 36.6529 33.7784 34.7494L31.9082 24.1333L39.763 16.5923C41.1843 15.2012 40.4362 12.8584 38.4912 12.5655ZM28.0182 22.8887L29.8135 32.9922L20.5374 28.2333L11.1865 32.9922L12.9818 22.8887L5.42627 15.7137L15.8245 14.2494L20.5374 5.02446L25.1755 14.2494L35.5737 15.7137L28.0182 22.8887Z"
      fill="#292B29"
    />
  </svg>
);
